<div class="btn-container d-flex align-items-center gap-3 justify-content-end">
    <app-action-buttons [searchLabel]="'Export PDF'" [isSubmitLoading]="isLoading" [isSubmitDisabled]="isLoading" (onSubmit)="SavePDF()" [showDiscard]="false"></app-action-buttons>
    <lucide-icon name="circle-x" role="button" color="black" (click)="modalService.dismissAll()"></lucide-icon>
</div>
<div #content id="htmlData" class="container" >

   
    <div class=" d-flex flex-column align-items-center">
        <h1>{{'Common.Invoice'| translate}}</h1>
        <span class="bold-text">{{'Common.InvoiceNO'| translate}}: </span>
        <span class="bold-text" style="direction: ltr;">{{data.BillRef}}</span>
        
        <span class="bold-text">{{'Common.StoreName'| translate}}: ATC</span>
        <!-- <span class="bold-text">العنوان</span> -->
    </div>
    
    <div class="d-flex justify-content-between w-70">
        <span class="bold-text">{{'Common.ClientName'| translate}}: {{data.CreatedBy.UserFullName}}</span>
        <span class="bold-text">{{'Common.Phone'| translate}}: {{data.CreatedBy.UserName}}</span>
    </div>

    <div class="d-flex justify-content-between w-70">
        <span class="bold-text">{{'Common.Date'| translate}}: {{data.Date | date: 'dd/MM/yyyy'}}</span>
        <span class="bold-text">{{'Common.Time'| translate}}: {{data.Date | date: 'hh:mm:ss' }}</span>
    </div>
    
    <div class="d-flex justify-content-start w-100">
        <p class="bold-text">{{'Common.TaxNumber'| translate}}: 310305072500003</p>
    </div>
    

    <hr style="border-top:dashed 2px #000000a6">
    <div class="d-flex">
        <span class="bold-text" style="width: 65%;">{{'Common.Products'| translate}}</span>
        <span class="bold-text" style="width: 20%;">{{'Common.Amount'| translate}}</span>
        <span class="bold-text" style="width: 15%;">{{'Common.Price'| translate}}</span>
    </div>
    
    <hr style="border-top:dashed 2px #000000a6">
    <ng-container>
        <div class="d-flex" *ngFor="let card of data.BillDetails">
            <span class="bold-text" style="width: 65%;">{{languageService.selectedLanguage=="ar" ? (card.Product.NameAr) : (card.Product.NameEn) }}</span>
            <span class="bold-text" style="width: 20%;">{{card.Quantity?? '--'}}</span>
            <span class="bold-text" style="width: 15%;">{{card.Price?? '--'}}</span>
        </div>
    </ng-container>
    <hr style="border-top:dashed 2px #000000a6">

    <!-- <table class="table">
        <thead>
            <tr>
                <th class="bold-text" style="width: 70%;">المنتجات</th>
                <th class="bold-text"> الكميه</th>
                <th class="bold-text"> السعر</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let card of data.cards">
            <td style="width: 70%;">{{card.CardName}}</td>
            <td>1</td>
            <td>{{card.Price}}</td>
            </tr>
        </tbody>
    </table> -->
    <!-- <hr style="border-top:dashed 2px #000000"> -->
    
    <div class="d-flex">
        <span class="bold-text">{{'Common.AmountWithAddVat'|translate}}: {{data.Total}}</span>
    </div>
    <div class="d-flex mt-3">
        <span class="bold-text">{{'Common.ServiceFees'|translate}}: {{data.Vat +  data.BankCommission}}</span>
    </div>
    <div class="d-flex mt-3">
        <span class="bold-text">{{'Common.Total'|translate}}: {{data.Total + data.Vat +  data.BankCommission}}</span>
    </div>
    <div class="d-flex mt-3">
        <span class="bold-text">{{'Common.PaidWith'|translate}}: {{data.CardOption}}</span>
    </div>
    <div class="d-flex mt-3">
        <span class="bold-text">{{'Common.PaymentCardNo'|translate}}: {{data.CardNumber}}</span>
    </div>
    
    <div class="d-flex justify-content-center mt-3">
        <span class="bold-text">>>>>>>>>>>>>{{'Common.CloseInvoice'|translate}}<<<<<<<<<<<<</span>
    </div>
    <div class="d-flex justify-content-center mt-3 barcode-container">
        <!-- <ejs-barcodegenerator id="barcode" style="display: block;" width="200px" height="100px" mode="SVG" type="Codabar" value="barValue"></ejs-barcodegenerator> -->
        <!-- <ngx-barcode [bc-value]="barValue" [bc-width]="1"></ngx-barcode> -->
        <ngx-barcode6
            [bc-format]="'CODE128'"
            [bc-value]="barValue"
            [bc-display-value]="true"
            [bc-width]=0.5
        >
        </ngx-barcode6>
    </div>
    <!-- <div class="d-flex justify-content-center"><span class="bold-text">{{data.BillRef}}</span></div> -->
</div>